export default __webpack_public_path__ + "static/media/A-graphic-medium.cf02e1bf.svg";